import { Property } from '@bbraun/bav-reporting/ui-report-editor';
import { marker as i18n } from '@ngneat/transloco-keys-manager/marker';
import { IS_GREATER_OR_EQUAL_NUMBER_ID } from '../../../../validation/factories/is-greater-or-equal-number-validator-factory';
import { IS_LOWER_OR_EQUAL_TO_PROPERTY_ID } from '../../../../validation/factories/is-lower-or-equal-to-property-validator-factory';
import { IS_NUMBER_INTEGER_ID } from '../../../../validation/factories/is-number-integer-validator-factory';

export function createMedicationEsaProperty(): Property {
  return {
    title: 'Patients treated with ESA',
    technicalName: 'medicationEsa',
    dataType: 'number',
    unit: null,
    highlighted: false,
    subName: null,
    formula: null,
    validation: [
      { validator: IS_NUMBER_INTEGER_ID },
      {
        validator: IS_GREATER_OR_EQUAL_NUMBER_ID,
        options: {
          config: {
            minimum: 0,
          },
        },
      },
      {
        validator: IS_LOWER_OR_EQUAL_TO_PROPERTY_ID,
        options: {
          config: {
            property: 'ownPatientHemoDialysis3Month',
          },
          messageKey: i18n(
            'bbraunBavReportingFeatureAisReports.validation.medicationEsa.notLowerOrEqual.numberOfChronicHdPatients.error.message',
          ),
        },
      },
    ],
  };
}
